import { render, staticRenderFns } from "./ProjectSummary.vue?vue&type=template&id=466a2174&scoped=true"
import script from "./ProjectSummary.vue?vue&type=script&lang=js"
export * from "./ProjectSummary.vue?vue&type=script&lang=js"
import style0 from "./ProjectSummary.vue?vue&type=style&index=0&id=466a2174&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466a2174",
  null
  
)

export default component.exports